import { jsx as _jsx } from "react/jsx-runtime";
import { Dialog, Text, useShowToast } from "@madmedical/ui";
import { skipToken } from "@madmedical/store";
import { useTranslation } from "@madmedical/i18n";
import { useDeleteCommentMutation, useGetCommentQuery } from "../api";
const DeleteCommentDialog = ({ id, open, onClose }) => {
    const { data: comment } = useGetCommentQuery(id !== null && id !== void 0 ? id : skipToken, {
        skip: !open,
    });
    const [deleteComment, { isLoading: isSubmitting }] = useDeleteCommentMutation();
    const showToast = useShowToast();
    const { t } = useTranslation();
    if (!id || !comment) {
        return null;
    }
    const handleConfirm = () => {
        void deleteComment(id)
            .unwrap()
            .then(() => {
            showToast(t("commentDeleted") + ".", { variant: "success" });
            onClose();
        });
    };
    return (_jsx(Dialog, Object.assign({ open: open, confirmLabel: t("delete"), onConfirm: handleConfirm, isSubmitting: isSubmitting, onClose: onClose }, { children: _jsx(Text, { children: t("sureToDeleteComment") }) })));
};
export default DeleteCommentDialog;
